import React from 'react'

import { useNavigationStore } from './state/navigationStore'
import { CasesTab } from './tabs/CasesTab'
import { ShortlistTab } from './tabs/ShortlistTab'
import { SystemsTab } from './tabs/SystemsTab'

const TabRouter = () => {
  const tab = useNavigationStore((state) => state.tab)

  switch (tab) {
    // case 'shortlist':
    //   return <ShortlistTab />
    case 'systems':
      return <SystemsTab />
    case 'cases':
      return <CasesTab />
    default:
      return <></>
  }
}

export { TabRouter }
